
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_o08jm_13h8s_9",
  "control": "awsui_control_o08jm_13h8s_45",
  "control-middle": "awsui_control-middle_o08jm_13h8s_52",
  "control-last": "awsui_control-last_o08jm_13h8s_52"
};
  